import * as React from "react";
import type { SVGProps } from "react";
const SvgCarRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#car-right_svg__a)">
      <path d="M12.84 11.99c.06.01.12.01.17.01l-.01.01a1 1 0 0 0 .99-.84c.09-.54-.28-1.06-.82-1.15l-6-1a.999.999 0 0 0-.33 1.97z" />
      <path
        fillRule="evenodd"
        d="M20.841 17h2.169v-.01c.55 0 1-.45 1-1v-2c0-1.43-1.76-4.26-6.46-5.87-.55-.53-1.15-1.02-2.16-1.57C13.62 5.58 11.61 5 10.01 5h-4c-.96 0-2.34.67-2.92 1.39L1.82 7.73C1.29 8.29 1 9.02 1 9.79v1.79l-.71.71a1.02 1.02 0 0 0-.29.69c-.008.367-.04 2.095.98 3.19.52.56 1.22.85 2.03.85a1 1 0 0 0 .174-.015A3.01 3.01 0 0 0 6.01 19c1.3 0 2.413-.838 2.828-2h6.172q.083 0 .164-.014a3.01 3.01 0 0 0 2.836 2.034c1.304 0 2.42-.843 2.831-2.02M6.01 13c1.3 0 2.413.838 2.828 2h6.172q.083 0 .164.014a3.01 3.01 0 0 1 2.836-2.034c1.304 0 2.42.843 2.831 2.02h1.169v-1c-.03-.38-1.07-2.66-5.31-4.05a.94.94 0 0 1-.4-.25c-.49-.49-.97-.9-1.88-1.4-1.15-.63-2.91-1.3-4.41-1.3h-4c-.34 0-1.18.42-1.41.71l-1.32 1.4c-.18.19-.27.43-.27.69v2.21c0 .27-.11.52-.29.71l-.71.71c.02.42.12 1.05.43 1.38.09.1.24.21.57.21q.082 0 .16.013A3.01 3.01 0 0 1 6.01 13m13 2.999c0-.56-.45-1.019-1-1.019s-1 .46-1 1.02.45 1.02 1 1.02 1-.46 1-1.019zM6.01 15c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="car-right_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCarRight;
